module.exports = require("filesize");